import { call, put, takeLatest, delay, select } from "redux-saga/effects";
import { push } from 'connected-react-router'
import ActionTypeConstants from "helpers/ActionTypeConstants";
import { actionApiCall } from "helpers/api/ApiCalls";

const getSelected = state => state.UserOrgSiteReducer.selected;

function* submitAddOfficerFormSaga({ payload }) {
    try {
        const selected = yield select(getSelected);
        const apiResponse = yield call(actionApiCall, {
            actionType: ActionTypeConstants.SUBMIT_ADD_OFFICER_FORM,
            data: { 
                email: payload.email,
                organization: selected.org,
                role: payload.role,
                password: payload.password,
                firstname: payload.firstname,
                lastname: payload.lastname,
                address_1: payload.address_1,
                address_2: payload.address_2,
                city: payload.city,
                country_name: payload.country_name,
                country_code: payload.country_code,
                state: payload.state,
                postcode: payload.postcode,
                phone: payload.phone,
                registered: true,
            }
        });
        if (apiResponse.res.data.response === 200) {
            yield put({
                type: ActionTypeConstants.SUBMIT_ADD_OFFICER_FORM_SUCCESS,
                payload
            });
            yield put(push('/maintain/users'));
            yield put({
                type: ActionTypeConstants.SHOW_ALERT,
                payload: {
                    message: apiResponse.res.data.message || "Account successfully created",
                    color: "success"
                }
            });
            yield delay(10000)
            yield put({ type: ActionTypeConstants.HIDE_ALERT });      
        } else {
            yield put({
                type: ActionTypeConstants.SHOW_ALERT,
                payload: {
                    message: apiResponse.res.data.message || "Error - Account create failed!",
                    color: "danger"
                }
            });
            yield delay(10000)
            yield put({
                type: ActionTypeConstants.HIDE_ALERT
            });
        }
    } catch (err) {
        yield put({
            type: ActionTypeConstants.SHOW_ALERT,
            payload: {
                message: "Error - Account create failed!",
                color: "danger"
            }
        });
        yield delay(10000)
        yield put({ type: ActionTypeConstants.HIDE_ALERT });
    }
}

export default function*() {
    yield takeLatest(
        ActionTypeConstants.SUBMIT_ADD_OFFICER_FORM,
        submitAddOfficerFormSaga
    );
}
